<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'studentRequirement', params: {} }">
            Student Requirement
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'studentRequirementView', params: {} }">
              View Student Requirement
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Student Requirement
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="studentRequirement.student">
            <td max-width="35%" class="text-subtitle-1">Student:</td>
            <td>
              {{ getRelationText(studentRequirement.student, "student", "firstName") }}
            </td>
          </tr>
          
          <tr v-if="studentRequirement.requirement">
            <td max-width="35%" class="text-subtitle-1">Requirement:</td>
            <td>
              {{ getRelationText(studentRequirement.requirement, "requirement", "name") }}
            </td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getStudentRequirement } from "@/services/studentRequirement";
    
              import { getAllStudents } from "@/services/student";
            
              import { getAllRequirements } from "@/services/requirement";
            

    export default {
      data() {
        return {
            id: '',
            studentRequirement: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "studentRequirementEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getStudentRequirement(this.id)
            .then((response) => {
              this.studentRequirement = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading studentRequirement");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          
            const params_student = {
              page: 0,
              size: 100
            };
            await getAllStudents(params_student)
              .then(response => {
                this.relations.student = response.data.content;
                return this.relations.student;
              });
            
            const params_requirement = {
              page: 0,
              size: 100
            };
            await getAllRequirements(params_requirement)
              .then(response => {
                this.relations.requirement = response.data.content;
                return this.relations.requirement;
              });
            
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    